module.exports = __webpack_public_path__ + "img/spc-full-logo.4af105de.png";